module.exports = __webpack_public_path__ + "static/media/phone-icon.10bc79b5.svg";